// Components
import { SMPFlex, SMPText, SMPRulesColorCircle, SMPWinIcon, SMPLossIcon, SMPDrawIcon } from '../../../../index';

// Utils
import { formatRuleType } from '@sportal365/smp-widget-utils';

// Types
import { IRule, IStandingsDataLabels, SportType } from '../../../../../types';
import { Sports } from '../../../../../constants/sportType';

interface IStandingsFooterProps {
  rules?: IRule[];
  sport?: SportType;
  dataLabels?: IStandingsDataLabels | null;
}

export const StandingsFooter = ({ rules, sport, dataLabels }: IStandingsFooterProps): JSX.Element => {
  return (
    <>
      <SMPFlex variant='standingsMarginals' wrap='wrap' gap='md' style={{ backgroundColor: 'var(--colors-subHeaderBgColor)' }}>
        {rules?.map((rule) => {
          const ruleType = formatRuleType(rule.type);

          return (
            <SMPFlex key={rule.id} css={{ mr: '$2' }}>
              <SMPRulesColorCircle rule={ruleType} />
              <SMPText variant='contrast' size='2'>
                {rule.name}
              </SMPText>
            </SMPFlex>
          );
        })}
      </SMPFlex>
      {sport === Sports.FOOTBALL && (
        <SMPFlex variant='standingsMarginals' style={{ backgroundColor: 'var(--colors-subHeaderBgColor)' }}>
          <SMPFlex css={{ alignItems: 'center', mr: '$2' }}>
            <SMPWinIcon width='3' height='3' />
            <SMPText variant='contrast' size='2' css={{ ml: '$1' }}>
              {dataLabels?.footer_win ?? 'Win'}
            </SMPText>
          </SMPFlex>
          <SMPFlex css={{ alignItems: 'center', mr: '$2' }}>
            <SMPLossIcon width='3' height='3' />
            <SMPText variant='contrast' size='2' css={{ ml: '$1' }}>
              {dataLabels?.footer_loss ?? 'Loss'}
            </SMPText>
          </SMPFlex>
          <SMPFlex css={{ alignItems: 'center', mr: '$2' }}>
            <SMPDrawIcon width='3' height='3' />
            <SMPText variant='contrast' size='2' css={{ ml: '$1' }}>
              {dataLabels?.footer_draw ?? 'Draw'}
            </SMPText>
          </SMPFlex>
        </SMPFlex>
      )}
    </>
  );
};
